import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Collection } from './collection.model';

export interface CollectionState extends EntityState<Collection> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'collection' })
export class CollectionStore extends EntityStore<CollectionState> {
	constructor() {
		super();
	}
}
